import { render, staticRenderFns } from "./CalendarCollapseBehavior.vue?vue&type=template&id=6e675a48&scoped=true&"
import script from "./CalendarCollapseBehavior.vue?vue&type=script&lang=js&"
export * from "./CalendarCollapseBehavior.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCollapseBehavior.vue?vue&type=style&index=0&id=6e675a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e675a48",
  null
  
)

export default component.exports